import English from "./English";
import Russian from "./Russian";

export default {
    English,
    Russian
};